import { Button, Divider, Flex, Text, VStack } from '@chakra-ui/react'
import { BlockContainer, BlockContent, BlockHeader } from '../components/shared/Block'
import { BsHouse, BsViewList } from 'react-icons/bs'
import TableAllQueues from '../components/queue/TableAllQueues'
import SearchQueuePanel from '../components/queue/SearchQueuePanel'
import { useState } from 'react'
import SearchQueryContext from '../context/searchQueryContext'
import { Link } from 'react-router-dom'

const Queue = ({ homeLink = false }) => {
    const [query, setQuery] = useState(null)

    return (
        <Flex p={{base:"",md:"40px"}} direction="column" w="full">
            <BlockContainer>
                <BlockHeader title="ตรวจสอบลำดับคิวการจองอาคารที่พัก" icon={BsViewList}>
                    {homeLink && <Link to="/"><Button variant="link" leftIcon={<BsHouse />}>กลับหน้าหลัก</Button></Link>}
                </BlockHeader>
                <Divider />
                <BlockContent mt={6}>
                    <VStack w="full" spacing={10}>
                        <SearchQueryContext.Provider value={[query, setQuery]}>
                            <SearchQueuePanel />
                            <Text fontWeight="bold">ผลลัพธ์การค้นหา</Text>
                            <TableAllQueues />
                        </SearchQueryContext.Provider>
                    </VStack>
                </BlockContent>
            </BlockContainer>
        </Flex>
    )
}

export default Queue